import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import CashierLayout from './layouts/CashierLayout';
import Dashboard from './pages/Dashboard';
import OrderHistory from './pages/OrderHistory';
import PrintReceiptPage from './pages/PrintReceiptPage';
import PrintReturnPage from './pages/PrintReturnPage';
import PrintExchangePage from './pages/PrintExchangePage';
import LoginPage from './pages/LoginPage';
import ProtectedRoute from './components/common/ProtectedRoute';
import {AuthInitializer} from './AuthInitializer';
import { ToastProvider } from './components/common/ToastProvider';
import SessionExpiredModal from './components/common/SessionExpiredModal';
import OrganizationSuspendedScreen from './components/common/OrganizationSuspendedScreen';
import StoreInactiveScreen from './components/common/StoreInactiveScreen';
import { PrinterProvider } from './context/PrinterContext';

function App() {
  return (
    <BrowserRouter>
      <ToastProvider>
        <PrinterProvider>
        <AuthInitializer>
          <SessionExpiredModal />
          <OrganizationSuspendedScreen />
          <StoreInactiveScreen />
          <Routes>
            <Route path="/login" element={<LoginPage />} />
            <Route path="/dashboard" element={
              <ProtectedRoute>
                <CashierLayout><Dashboard /></CashierLayout>
              </ProtectedRoute>
            } />
            <Route path="/orders" element={
              <ProtectedRoute>
                <CashierLayout><OrderHistory /></CashierLayout>
              </ProtectedRoute>
            } />
            <Route path="/print/receipt/:orderId" element={
              <ProtectedRoute>
                <PrintReceiptPage />
              </ProtectedRoute>
            } />
            <Route path="/print/return/:orderId/:returnId" element={
              <ProtectedRoute>
                <PrintReturnPage />
              </ProtectedRoute>
            } />
            <Route path="/print/exchange/:orderId/:exchangeId" element={
              <ProtectedRoute>
                <PrintExchangePage />
              </ProtectedRoute>
            } />
            <Route path="/" element={<Navigate to="/dashboard" replace />} />
          </Routes>
        </AuthInitializer>
        </PrinterProvider>
      </ToastProvider>
    </BrowserRouter>
  );
}

export default App;
